<template>
  <div>
    <div class="title">查看评分明细</div>
    <!-- <a-page-header
        style="border: 1px solid rgb(235, 237, 240)"
        title=""
        @back="() => null"
      /> -->
    <a-card>
      <!-- 查询 -->
      <!-- <SearchView
        :renderItem="searchSchema"
        :formLayout="formLayout"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView> -->
    </a-card>
    <a-card style="margin-top:20px;">
      <!-- 结果 -->
      <TableView
        ref="table"
        :columns="columns"
        :scroll="scroll"
        :data="tableData"
        :pagination="false"
      ></TableView>
    </a-card>
  </div>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData } from './api'

export default {
  mixins: [mixin],
  components: {
    TableView,
  },
  data() {
    return {
      loading: '',
      scroll: { x: 800 }, //滚动设置
      formLayout: 'inline',
      tableData: [],
      frozenText: '',
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    //获取table数据
    async _getTableData() {
      try {
        const query = {
          //  这条我从测试复制了一条到生产，你可以先用这条数据开发
          // id: '202106221804330014'
          id: this.$route.query.id,
        }
        const result = await getTableData(query)
        console.log(result)
        this.tableData = result.data.processes
        /*** 模拟数据***/
        // this.tableData = [
        //   {
        //     type: '基础分',
        //     name: '公司成立年限',
        //     value: '1997',
        //     score: 10,
        //     wright: '15%',
        //     bs: 1.5
        //   },
        //   {
        //     type: '基础分2',
        //     name: '公司成立年限2',
        //     value: '1997',
        //     score: 10,
        //     wright: '15%',
        //     bs: 1.5
        //   },
        //   {
        //     type: '基础分3',
        //     name: '公司成立年限3',
        //     value: '1997',
        //     score: 10,
        //     wright: '15%',
        //     bs: 1.5
        //   }
        // ]
        /*** 模拟数据***/
        this.tableData.push({
          type: '',
          name: '总分',
          value: '',
          score: result.data.score,
          wright: '',
          bs: '',
        })
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    // handelSearch(query) {
    //   this.searchData.name = query.name
    //   this.searchData.username = query.username
    //   this.searchData.status = query.status
    //   this._getTableData()
    // },
    //跳转详情页
    // async handelDetail(row) {
    //   const { name, code, id } = row
    //   this.SET_COMPANY({ name, code })
    //   this.$router.push({ name: 'trend', params: { id, code } })
    // const {
    //   data: { permissions }
    // } = await getCustomerOverview(id)
    // this.permissions = permissions
    // this.SET_PERMISSIONS(this.permissionsObj())
    // },
    //分页
    // handlePagination(pagination) {
    //   ;({
    //     current: this.pageData.current,
    //     pageSize: this.pageData.pageSize,
    //     total: this.pageData.total
    //   } = pagination)

    //   this._getTableData()
    // }
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
.title {
  font-size: 16px;
  font-weight: 700;
}
</style>
